import * as React from 'react'

const SvgIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || '78'}
    height={props.height || '78'}
    fill='none'
    viewBox='0 0 78 78'
    {...props}
  >
    <path
      fill={props.fill || '#E42692'}
      d='m48.46 19.737-6.695 10.321 3.784.333L29.54 44.374l6.112-10.32h-2.781l2.78-14.317H22.05v38.526h12.328V50.84l9.246-8.077v15.499h12.328V19.737z'
    ></path>
    <path
      fill={props.fill || '#E42692'}
      d='M71.5 39C71.5 21.05 56.95 6.5 39 6.5S6.5 21.05 6.5 39 21.05 71.5 39 71.5V78C17.46 78 0 60.54 0 39S17.46 0 39 0s39 17.46 39 39-17.46 39-39 39v-6.5c17.95 0 32.5-14.55 32.5-32.5'
    ></path>
  </svg>
)

export default React.memo(SvgIcon)
